export default
  [
    {
      path: '',
      redirect: 'bulkAccount'
    },
    // 散货台账
    {
      path: 'bulkAccount',
      name: 'financialCenter/bulkAccount',
      component: () => import('@/page/financialCenter/bulkAccount'),
      meta: {
        openKeyName: '散货台账', selectKeyUrl: 'bulkAccount'
      }
    },
    // 费用以及账单
    {
      path: 'receivableDetails',
      name: 'financialCenter/receivableDetails',
      component: () => import('@/page/financialCenter/receivableDetail'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'receivableDetails'
      }
    },
    {
      path: 'receivableBill',
      name: 'financialCenter/receivableBill',
      component: () => import('@/page/financialCenter/receivableBill'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'receivableBill'
      }
    },
    {
      path: 'receivableBill/:id/opt',
      name: 'financialCenter/receivableBillOpt',
      component: () => import('@/page/financialCenter/billOperate'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'receivableBill'
      },
      props: true
    },
    {
      path: 'payableDetails',
      name: 'financialCenter/payableDetails',
      component: () => import('@/page/financialCenter/payableDetail'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'payableDetails'
      }
    },
    {
      path: 'payableBill',
      name: 'financialCenter/payableBill',
      component: () => import('@/page/financialCenter/payableBill'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'payableBill'
      }
    },
    {
      path: 'payableBill/:id/opt',
      name: 'financialCenter/payableBillOpt',
      component: () => import('@/page/financialCenter/billOperate'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'payableBill'
      },
      props: true
    },
    {
      path: 'billReceivableDetail/:id',
      name: 'financialCenter/billReceivableDetail',
      component: () => import('@/page/financialCenter/billDetailList'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'receivableBill'
      },
      props: true
    },
    {
      path: 'billPayableDetail/:id',
      name: 'financialCenter/billPayableDetail',
      component: () => import('@/page/financialCenter/billDetailList'),
      meta: {
        openKeyName: '费用及账单', selectKeyUrl: 'payableBill'
      },
      props: true
    },
    // 其他
    {
      path: 'custManagement',
      name: 'financialCenter/custManagement',
      component: () => import('@/page/financialCenter/custManagement'), // 结算对象
      meta: {
        openKeyName: '其他', selectKeyUrl: 'custManagement'
      }
    },
    {
      path: 'createCustManagement',
      name: 'financialCenter/createCustManagement',
      component: () => import('@/page/financialCenter/custManagementOperation'), // 结算对象
      meta: {
        openKeyName: '其他', selectKeyUrl: 'custManagement'
      }
    },
    {
      path: 'custManagement/opt',
      name: 'financialCenter/custManagementOperation',
      component: () => import('@/page/financialCenter/custManagementOperation'), // 结算对象操作
      meta: {
        openKeyName: '其他', selectKeyUrl: 'custManagement'
      }
    },
    {
      path: 'custManagement/:id',
      name: 'financialCenter/custManagementDetail',
      component: () => import('@/page/financialCenter/custManagementDetail'), // 结算对象详情
      meta: {
        openKeyName: '其他', selectKeyUrl: 'custManagement'
      },
      props: true
    },
    {
      path: 'costTypeManagement',
      name: 'financialCenter/costTypeManagement',
      component: () => import('@/page/financialCenter/costTypeManagement'), // 费用
      meta: {
        openKeyName: '其他', selectKeyUrl: 'costTypeManagement'
      }
    },
    {
      path: 'insuranceCompanyManagement',
      name: 'financialCenter/insuranceCompanyManagement',
      component: () => import('@/page/financialCenter/insuranceCompanyManagement'), // 费用
      meta: {
        openKeyName: '其他', selectKeyUrl: 'insuranceCompanyManagement'
      }
    },
    // -----------------陆运
    // 陆运台账
    {
      path: 'truckAccount',
      name: 'financialCenter/truckAccount',
      component: () => import('@/page/financialCenter/landTransportation/truckAccount'),
      meta: {
        openKeyName: '陆运台账', selectKeyUrl: 'truckAccount'
      }
    },

    // 陆运费用及账单
    {
      path: 'truckReceivableDetails',
      name: 'financialCenter/truckReceivableDetails',
      component: () => import('@/page/financialCenter/landTransportation/truckReceivableDetails'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckReceivableDetails'
      }
    },
    {
      path: 'truckReceivableBill',
      name: 'financialCenter/truckReceivableBill',
      component: () => import('@/page/financialCenter/landTransportation/truckReceivableBill'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckReceivableBill'
      }
    },
    {
      path: 'truckReceivableBill/:id/opt',
      name: 'financialCenter/truckreceivableBillOpt',
      component: () => import('@/page/financialCenter/landTransportation/truckbillOperate'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckReceivableBill'
      },
      props: true
    },
    {
      path: 'truckBillReceivableDetail/:id',
      name: 'financialCenter/truckBillReceivableDetail',
      component: () => import('@/page/financialCenter/landTransportation/truckBillDetailList'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckReceivableBill'
      },
      props: true
    },
    {
      path: 'truckPayableBill',
      name: 'financialCenter/truckPayableBill',
      component: () => import('@/page/financialCenter/landTransportation/truckPayableBill'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckPayableBill'
      }
    },
    {
      path: 'truckPayableBill/:id/opt',
      name: 'financialCenter/truckpayableBillOpt',
      component: () => import('@/page/financialCenter/landTransportation/truckbillOperate'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckPayableBill'
      },
      props: true
    },
    {
      path: 'truckBillPayableDetail/:id',
      name: 'financialCenter/truckBillPayableDetail',
      component: () => import('@/page/financialCenter/landTransportation/truckBillDetailList'),
      meta: {
        openKeyName: '陆运费用及账单', selectKeyUrl: 'truckPayableBill'
      },
      props: true
    },

    // 陆运费用配置
    {
      path: 'truckCustManagement',
      name: 'financialCenter/truckCustManagement',
      component: () => import('@/page/financialCenter/landTransportation/custManagement'),
      meta: {
        openKeyName: '陆运费用配置', selectKeyUrl: 'truckCustManagement'
      }
    },
    {
      path: 'createTruckCustManagement',
      name: 'financialCenter/createTruckCustManagement',
      component: () => import('@/page/financialCenter/landTransportation/custManagementOperation'), // 陆运结算对象
      meta: {
        openKeyName: '陆运费用配置', selectKeyUrl: 'truckCustManagement'
      }
    },
    {
      path: 'truckCustManagement/opt',
      name: 'financialCenter/truckCustManagementOperation',
      component: () => import('@/page/financialCenter/landTransportation/custManagementOperation'), // 陆运结算对象操作
      meta: {
        openKeyName: '陆运费用配置', selectKeyUrl: 'truckCustManagement'
      }
    },
    {
      path: 'truckCustManagement/:id',
      name: 'financialCenter/truckCustManagementDetail',
      component: () => import('@/page/financialCenter/landTransportation/custManagementDetail'), // 陆运结算对象详情
      meta: {
        openKeyName: '陆运费用配置', selectKeyUrl: 'truckCustManagement'
      },
      props: true
    },
    {
      path: 'truckCostTypeManagement',
      name: 'financialCenter/truckCostTypeManagement',
      component: () => import('@/page/financialCenter/landTransportation/costTypeManagement'),
      meta: {
        openKeyName: '陆运费用配置', selectKeyUrl: 'truckCostTypeManagement'
      }
    },
    // {
    //   path: 'truckInsuranceCompanyManagement',
    //   name: 'financialCenter/truckInsuranceCompanyManagement',
    //   component: () => import('@/page/financialCenter/landTransportation/insuranceCompanyManagement'),
    //   meta: {
    //     openKeyName: '陆运费用配置', selectKeyUrl: 'truckInsuranceCompanyManagement'
    //   }
    // },
  ]



// WEBPACK FOOTER //
// ./src/router/financialCenter/index.js